export const ErrorViewGrid = {
	size: 100,
	gap: 0,
	name: 'error_holder',
	padding: {
		top: 10,
		bottom: 20
		// portrate: {
		//     left: 10,
		//     right: 10,
		// }
	},
	main: [
		{
			name: 'errorgrid',
			size: 100,
			type: 'PortrateGridController',
			config: {
				name: 'errorgrid2',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 10
					},
					{
						name: 'error_img',
						size: 35,
						bounds: {
							width: 300,
							height: 220
						},
						// height: 60,
						align: 'bottom_center'
					},
					{
						name: 'empty',
						size: 12
					},
					{
						name: 'error_info',
						size: 45,
						align: 'top_center',
						height: 30
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'errorgrid-landscape',
			size: 100,
			type: 'PortrateGridController',
			config: {
				name: 'errorgrid2',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 14
					},
					{
						name: 'error_img',
						size: 35,
						// bounds: {
						//   width: 850,
						//   height: 620,
						// },
						height: 100,
						align: 'bottom_center'
					},
					// {
					//   name: "empty",
					//   size: 8,
					// },
					{
						name: 'error_info',
						size: 45,
						align: 'top_center',
						height: 30
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'empty',
			size: 20
		},
		{
			name: 'error_img',
			size: 35,
			// bounds: {
			//   width: 300,
			//   height: 540,
			// },
			height: 100,
			align: 'bottom_center'
		},
		// {
		//   name: "empty",
		//   size: 1,
		// },
		{
			name: 'error_info',
			size: 40,
			align: 'top'
			// height: 60,
		}
	]
};
